import { DialogRef } from '@agent-ds/shared/components/dialog/dialog-ref';
import { Component } from '@angular/core';

@Component({
  selector: 'ag-job-az-check-step-send-to-company',
  templateUrl: './job-az-check-step-send-to-company.component.html',
  styleUrls: ['./job-az-check-step-send-to-company.component.scss'],
})
export class JobAzCheckStepSendToCompanyComponent {
  constructor(public dialog: DialogRef) {}
}
